import { useSignal } from "@preact/signals-react";
import { ErrorField } from "../../../../types/ErrorField";
import TextEdit from "../../../molecules/TextEdit";
import { getErrorMessage } from "../../../../utils/formErrorUtils";
import CurrencyInput from "../../../molecules/CurrencyInput";
import { MdOutlineScore } from "react-icons/md";
import FileUpload from "../../../molecules/FileUpload";
import { FiTrash2 } from "react-icons/fi";

interface Props {
    form: any;
    errorFields: ErrorField[];
    changeForm: (field: string, value: string | File | null) => void;
    editForm?: boolean;
}

const GuarantorRetailFormTab: React.FC<Props> = ({ form, errorFields, changeForm, editForm = false }) => {

    const logoPreview = useSignal<string | null>(form.logo ? form.logo : null);

    const handleUpload = (file: File) => {
        const url = URL.createObjectURL(file);
        logoPreview.value = url;
        changeForm('logo', file);
    };

    const handleRemove = () => {
        logoPreview.value = null;
        changeForm('logo', null);
    };

    return (
        <div className="p-4 m-4">
            <div className="grid grid-cols-12 gap-4">
                <CurrencyInput
                    id="guaranteePercentage"
                    label="Aval"
                    className="col-span-2"
                    prefix="%"
                    value={form.guaranteePercentage}
                    fractionDigits={0}
                    onChange={(value) => changeForm("guaranteePercentage", value.toString())}
                    errorMessage={getErrorMessage(errorFields, "guaranteePercentage")}
                    disabled={!editForm}
                />
                <div />
                <CurrencyInput
                    id="score"
                    label="Score"
                    className="col-span-2"
                    prefix={<MdOutlineScore />}
                    value={form.score}
                    fractionDigits={2}
                    onChange={(value) => changeForm("score", value.toString())}
                    errorMessage={getErrorMessage(errorFields, "score")}
                    disabled={!editForm}
                />
                <div />
                <CurrencyInput
                    id="limit"
                    label="Limite Aprovado"
                    className="col-span-2"
                    prefix="R$"
                    fractionDigits={2}
                    value={form.limit}
                    onChange={(value) => changeForm("limit", value.toString())}
                    errorMessage={getErrorMessage(errorFields, "limit")}
                    disabled={!editForm}
                />
            </div>

            <div className="grid grid-cols-12 gap-4 mt-6">
                <TextEdit
                    id="alias"
                    name="alias"
                    label="Link único da parceira"
                    className="col-span-7"
                    prefix={
                        <div className="inset-shadow-2xs px-4 py-2 text-sm font-medium text-gray-900 w-[310px] rounded-l-lg bg-white border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700">
                            https://emprestimo.agrolend.agr.br/parceiro/
                        </div>}
                    labelClassName="ml-80"
                    value={form.alias}
                    onChange={(e) => {
                        const sanitized = e.target.value
                            .toLowerCase()
                            .replace(/[^a-z0-9_-]/g, '');
                        changeForm("alias", sanitized);
                    }}
                    errorMessage={getErrorMessage(errorFields, "alias")}
                    disabled={!editForm}
                />
            </div>
            <div className="grid grid-cols-1 gap-4 mt-6">
                {logoPreview.value ? (
                    <div className="relative inline-block w-fit">
                        <img src={logoPreview.value ?? undefined} alt="Logo preview" className="h-80 w-auto rounded shadow border" />
                        {editForm && (
                            <button
                                type="button"
                                onClick={handleRemove}
                                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-2 shadow-md ring-2 ring-white hover:bg-red-700 transition"
                                title="Remover imagem"

                            >
                                <FiTrash2 className="w-4 h-4" />
                            </button>
                        )}
                    </div>
                ) : (
                    <FileUpload
                        id="logo"
                        name="logo"
                        label="Arquivo enviado:"
                        errorMessage={getErrorMessage(errorFields, 'logo')}
                        onUploadFile={handleUpload}
                        onRemoveFile={handleRemove}
                        accept=".png, .jpeg, .jpg"
                        info="PNG, JPEG ou JPG (MAX. 2MB)"
                    />
                )}
            </div>
        </div>
    );
};

export default GuarantorRetailFormTab;
